import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { LoaderComponent } from '../../../../common-component/loader/loader.component';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonUtilService } from '../../../../services/common-util/common-util.service';
import { ToastrService } from 'ngx-toastr';
import { ManageUserService } from '../../../../services/raintree/Transmission/manage-user.service';
import { AppConfigService } from '../../../../services/config/app-config.service';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

@Component({
  selector: 'app-manage-userPermission-dialog',
  standalone: true,
  imports: [
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatInputModule,
    LoaderComponent,
    ReactiveFormsModule,
    FormsModule,
    InfiniteScrollModule
],
  templateUrl: './manage-userDetails-dialog.component.html',
  styleUrls: [
    './manage-userDetails-dialog.component.scss',
    '../../../../../styles/_dropdown.scss',
  ],
})

export class ManageUserDetailsDialogComponent implements OnInit {
  isMobileView: boolean = false;
  isLoading: boolean = false;
  userData: any;
  isSuperUser: any;
  isResetAllowed: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private isMobile: CommonUtilService,
    private toaster: ToastrService,
    private _manageUserService: ManageUserService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<ManageUserDetailsDialogComponent>,
    private appConfigService: AppConfigService,
  ){}

  manageUserPermALL :any = []
  manageUserPermWithLoc: any = []
  ngOnInit(): void {
    this.isMobileView= this.isMobile.isMobileDevice();
    this.userData = this.data.userDetails;
    this.isSuperUser = this.data.isSuperUser;
    this.isResetAllowed = this.allowReset();
    this.getUserDetails();
  }

  getUserDetails() {
    this.isLoading=true;
    this._manageUserService.getUserDetails(this.userData.id).subscribe({
      next: (response:any) => {
        this.userData = response.data;
        this.isLoading=false;
      }, error: (error) => {
        this.isLoading=false;
      }
    });
  }

  allowReset() {
    return this.data.isSuperUser
  }

  closeDialog(){
    this.dialogRef.close(true);
  }

  saveChanges(){
    if(!this.userData.family_code || this.userData.family_code.length==0) {
      this.toaster.error('User Family Code already reset.');
      this.isLoading = false;
    } else if(this.isSuperUser){
      this._manageUserService.resetUserFC(this.data.userDetails.id).subscribe({
        next: (response)=>{
          if(!response.error){
            this.getUserDetails();
            this.toaster.success('User Family Code Reset successfully')
          }
        },
        error: (error)=>{
          this.isLoading = false;
          this.toaster.error(error);
        }
      });
    }
  }
};